import { useCallback, useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';
import { ContractNames } from '../constants';
import { findNextMatrixLevel, nextLevelToMaxActive } from '../program';
import { useGetContract } from './useGetContract';
import { getPublicRpcProvider } from './usePassiveIncome';

export const useOnchainActiveLevels = (userAddress) => {
  const { account, provider } = useWeb3React();
  const { getContract } = useGetContract();
  const [levels, setLevels] = useState({ x2: null, x4: null });
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!userAddress) {
      setLevels({ x2: null, x4: null });
      return;
    }

    const readProvider = account && provider ? provider.getSigner(account).connectUnchecked() : provider || getPublicRpcProvider();
    if (!readProvider) {
      return;
    }

    setIsLoading(true);
    try {
      const contract = await getContract(ContractNames.MATRIX_X2X4, readProvider);
      const [nextX2, nextX4] = await Promise.all([
        findNextMatrixLevel(contract, userAddress, true),
        findNextMatrixLevel(contract, userAddress, false),
      ]);

      setLevels({
        x2: nextLevelToMaxActive(nextX2),
        x4: nextLevelToMaxActive(nextX4),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [account, getContract, provider, userAddress]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    x2: levels.x2,
    x4: levels.x4,
    isLoading,
    refresh,
  };
};
